import { render, staticRenderFns } from "./InputRestaurantInfo.vue?vue&type=template&id=13152670&scoped=true&"
import script from "./InputRestaurantInfo.vue?vue&type=script&lang=js&"
export * from "./InputRestaurantInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13152670",
  null
  
)

export default component.exports